/* global REACT_APP_PUBLIC_FEATURE_FLAGS */
const flags: string[] = typeof REACT_APP_PUBLIC_FEATURE_FLAGS !== 'undefined' ? REACT_APP_PUBLIC_FEATURE_FLAGS : [];

export const ENABLE_ORDERS_V2 = flags.includes('orders-v2');
export const ENABLE_COMMERCE_V2 = flags.includes('commerce-v2');
export const ENABLE_DELIVERY_V2 = flags.includes('delivery-v2');
export const ENABLE_HORARIOS_V2 = flags.includes('horarios-v2');
export const ENABLE_AJUSTES_V2 = flags.includes('ajustes-v2');
export const ENABLE_MENU_V2 = flags.includes('menu-v2');
